// extracted by mini-css-extract-plugin
export default {"geofence":"ChooseGeofenceModal_geofence__XFzdL"};